/*
 * @Author: your name
 * @Date: 2021-10-26 10:59:26
 * @LastEditTime: 2022-03-03 17:31:50
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /cloudoffice/assets/doclib/src/constants/codeTable.js
 */
// import { defineMessage } from '@/core/dataHandler';
export const FileTypeMap = {
  'png': 'image',
  'jpg': 'image',
  'jpeg': 'image',
  'templateFolder': 'folder',
  'folder': 'collab-folder',
  'doc': 'doc',
  'docx': 'doc',
  'rtf': 'doc',
  'wps': 'doc',
  'wpt': 'doc',
  'odt': 'doc',
  'docm': 'doc',
  'dot': 'doc',
  'dotm': 'doc',
  'dotx': 'doc',
  'ppt': 'ppt',
  'pptx': 'ppt',
  'odp': 'ppt',
  'dps': 'ppt',
  'dpt': 'ppt',
  'ppsx': 'ppt',
  'pot': 'ppt',
  'potm': 'ppt',
  'potx': 'ppt',
  'pps': 'ppt',
  'ppsm': 'ppt',
  'pptm': 'ppt',
  'xls': 'xls',
  'xlt': 'xls',
  'ett': 'xls',
  'xlsx': 'xls',
  'xltx': 'xls',
  'ods': 'xls',
  'et': 'xls',
  'xlsb': 'xls',
  'xlsm': 'xls',
  'xltm': 'xls',
  'pdf': 'pdf',
  'psd': 'psd',
  'html': 'html',
  'xhtml': 'html',
  'htm': 'html',
  'ai': 'ai',
  'csv': 'csv',
  'ydoc': 'ydoc',
  'yxls': 'yxls',
  'vsd': 'visio',
  'vsdx': 'visio',
  'vsdm': 'visio',
  'vdw': 'visio',
  'mpp': 'project',
  'markdown': 'text',
  'md': 'text',
  'mdown': 'text',
  'tsv': 'text',
  'kanban': 'text',
  'ngm': 'file-flow',
  'km': 'file-mind',
  'txt': 'text',
  'mp4': 'video',
  'mp3': 'video',
  'flv': 'video',
  'm4v': 'video',
  'f4v': 'video',
  'mov': 'video',
  '3gp': 'video',
  'wmv': 'video',
  'mpga': 'video',
  'mpv': 'video',
  'qt': 'video',
  'bhd': 'video',
  'ram': 'video',
  'rma': 'video',
  'spx': 'video',
  'divx': 'video',
  'mod': 'video',
  'wm': 'video',
  '3g2': 'video',
  'm2ts': 'video',
  'ts': 'video',
  'mpg': 'video',
  'mkv': 'video'
}
